export const Resource = {
  AKAMAI_TRAFFIC_CUSTOM_MB: 'akamai-traffic-custom-mb',
  AKAMAI_TRAFFIC_MB: 'akamai-traffic-mb',
  GCORE_TRAFFIC_CUSTOM_MB: 'gcore-traffic-custom-mb',
  GCORE_TRAFFIC_MB: 'gcore-traffic-mb',
  GCORE_TRAFFIC_ORIGIN_MB: 'gcore-traffic-origin-mb',
  STREAMING: 'gcore-streaming-minutes'
}